import { grey } from '../../../utils/brandColors';

export default () => ({
  paperRoot: {
    overflow: 'auto',
    marginTop: '1rem',
  },
  row: {
    cursor: 'pointer',
    '&:hover': { background: grey[50] },
  },
  taskNameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  taskName: {
    display: 'flex',
    marginRight: 4,
    fontSize: 18,
  },
  statusCell: {
    padding: '.5em',
    minWidth: 200,
    maxWidth: 300,
  },
});
